export const environment = {
    production: false,
    apiUrl: 'https://digital-dev.icysmoke-f59af592.germanywestcentral.azurecontainerapps.io',
    version: '1.0-dev',
  };
  
